var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 44,
    viewBox: "0 0 156 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9095 17.0355C12.4479 16.6708 12.3694 16.0009 12.7341 15.5394L14.5398 13.2539C14.9045 12.7924 15.5743 12.7138 16.0359 13.0785V13.0785C16.4974 13.4432 16.576 14.113 16.2113 14.5746L14.4056 16.86C14.0409 17.3216 13.3711 17.4001 12.9095 17.0355V17.0355Z",
    fill: "#4AFEBF",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0278 21.0229C25.0278 22.96 23.4575 24.5303 21.5205 24.5303C19.5835 24.5303 18.0132 22.96 18.0132 21.0229C18.0132 19.0859 19.5835 17.5156 21.5205 17.5156C23.4575 17.5156 25.0278 19.0859 25.0278 21.0229Z",
    fill: "#51EEDA",
    id: "path4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8458 35.3682C22.6274 36.8021 20.4141 36.8021 19.1957 35.3682L9.10788 23.4963C8.13985 22.3571 8.13984 20.6842 9.10788 19.545L10.1171 18.3573C10.6626 17.7153 11.6254 17.637 12.2674 18.1826C12.9095 18.7282 12.9877 19.6909 12.4421 20.333L11.4329 21.5206L21.5208 33.3925L24.4441 29.9521C24.9897 29.3101 25.9524 29.2319 26.5945 29.7774C27.2365 30.323 27.3147 31.2857 26.7692 31.9278L23.8458 35.3682ZM30.1524 25.5903C29.5104 25.0447 29.4322 24.082 29.9777 23.4399L31.6086 21.5206L21.5208 9.64874L19.3961 12.1491C18.8506 12.7911 17.8878 12.8694 17.2458 12.3238C16.6038 11.7782 16.5255 10.8155 17.0711 10.1734L19.1957 7.67309C20.4141 6.2392 22.6274 6.2392 23.8458 7.67309L33.9336 19.545C34.9017 20.6842 34.9017 22.3571 33.9336 23.4963L32.3028 25.4156C31.7572 26.0576 30.7945 26.1358 30.1524 25.5903Z",
    fill: "url(#paint0_linear)",
    id: "path6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5207 3.05107C11.3202 3.05107 3.05107 11.3202 3.05107 21.5207C3.05107 31.7211 11.3202 39.9902 21.5207 39.9902C22.3632 39.9902 23.0462 40.6732 23.0462 41.5158C23.0462 42.3583 22.3632 43.0413 21.5207 43.0413C9.63512 43.0413 0 33.4062 0 21.5207C0 9.63512 9.63512 0 21.5207 0C22.3632 0 23.0462 0.683004 23.0462 1.52553C23.0462 2.36806 22.3632 3.05107 21.5207 3.05107Z",
    fill: "url(#paint1_linear)",
    id: "path8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5106 36.7981C33.9176 36.1996 33.922 35.2337 34.5205 34.6407C37.9 31.292 39.9904 26.6519 39.9904 21.5207C39.9904 16.3895 37.9 11.7493 34.5205 8.40065C33.922 7.80763 33.9176 6.84173 34.5106 6.24325C35.1036 5.64477 36.0695 5.64035 36.668 6.23337C40.602 10.1315 43.0415 15.5426 43.0415 21.5207C43.0415 27.4987 40.602 32.9098 36.668 36.808C36.0695 37.401 35.1036 37.3966 34.5106 36.7981Z",
    fill: "url(#paint2_linear)",
    id: "path10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5978 39.9968C30.5978 40.9025 29.8635 41.6367 28.9578 41.6367C28.0521 41.6367 27.3179 40.9025 27.3179 39.9968C27.3179 39.091 28.0521 38.3568 28.9578 38.3568C29.8635 38.3568 30.5978 39.091 30.5978 39.9968Z",
    fill: "#4AFEBF",
    id: "path12"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 141.60392,34.610529 h -3.05086 V 17.183988 h 1.95256 l 0.53635,1.903739 c 0.92806,-1.147124 2.4653,-2.172215 4.75936,-2.172215 3.41696,0 5.85766,2.92883 5.85766,6.638682 0,3.685445 -2.4407,6.638682 -5.85766,6.638682 -2.09822,0 -3.53901,-1.147125 -4.19741,-2.050181 z m 3.44158,-7.200042 c 2.0982,0 3.5144,-1.65967 3.5144,-3.856293 0,-2.22103 -1.4162,-3.856294 -3.5144,-3.856294 -2.02636,0 -3.46618,1.684078 -3.46618,3.856294 0,2.147809 1.43982,3.856293 3.46618,3.856293 z",
    fill: "#ffffff",
    id: "path12-3",
    style: {
      strokeWidth: 0.098415
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 122.44154,23.554194 c 0,-3.734259 2.80679,-6.638682 6.61448,-6.638682 3.80766,0 6.61447,2.904423 6.61447,6.638682 0,3.734259 -2.80681,6.638682 -6.61447,6.638682 -3.80769,0 -6.61448,-2.904423 -6.61448,-6.638682 z m 6.61448,3.856293 c 2.07459,0 3.51439,-1.65967 3.51439,-3.856293 0,-2.22103 -1.4398,-3.856294 -3.51439,-3.856294 -2.07459,0 -3.53901,1.635264 -3.53901,3.856294 0,2.196623 1.46442,3.856293 3.53901,3.856293 z",
    fill: "#ffffff",
    id: "path14-6",
    style: {
      strokeWidth: 0.098415
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 119.55601,29.9244 h -3.05086 V 11.545989 h 3.05086 z",
    fill: "#ffffff",
    id: "path16-7",
    style: {
      strokeWidth: 0.098415
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 113.60486,24.725726 H 104.282 c 0.36611,1.806112 1.65928,2.806796 3.56263,2.806796 1.39159,0 2.22122,-0.268476 3.56361,-1.195939 l 1.41619,2.050181 c -1.56284,1.293567 -3.00265,1.806112 -5.07723,1.806112 -3.8559,0 -6.58987,-2.904423 -6.58987,-6.638682 0,-3.734259 2.85601,-6.638682 6.46783,-6.638682 3.92971,0 5.9797,3.050865 5.9797,6.687496 z m -9.34746,-2.196623 h 6.3458 c -0.14664,-1.537635 -1.05009,-3.002051 -2.95344,-3.002051 -1.73308,0 -3.05087,1.073905 -3.39236,3.002051 z",
    fill: "#ffffff",
    id: "path18-5",
    style: {
      strokeWidth: 0.098415
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 95.083164,29.9244 h -3.02627 L 86.955649,17.183988 h 3.196917 l 3.393351,8.859712 h 0.04824 l 3.392357,-8.859712 h 3.172896 z",
    fill: "#ffffff",
    id: "path20-3",
    style: {
      strokeWidth: 0.098415
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76.915846,29.9244 H 73.864981 V 17.183988 h 1.97696 l 0.585766,2.074588 c 0.536953,-0.951869 1.976961,-2.343064 4.027143,-2.343064 2.684763,0 4.686129,1.391195 4.686129,5.540371 V 29.9244 h -3.026457 v -7.0536 c 0,-2.196623 -1.025091,-3.124085 -2.538322,-3.124085 -1.586449,0 -2.660354,1.269159 -2.660354,3.270527 z",
    fill: "#ffffff",
    id: "path22-5",
    style: {
      strokeWidth: 0.098415
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 70.50716,29.9244 H 58.3037 V 12.839556 h 12.081425 v 2.806796 h -8.95734 v 4.271211 h 8.518016 v 2.806795 h -8.518016 v 4.393246 h 9.079375 z",
    fill: "#ffffff",
    id: "path24-6",
    style: {
      strokeWidth: 0.098415
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs43"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 21.5208,
    y1: 36.4436,
    x2: 21.5208,
    y2: 6.59767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AFEBF",
    id: "stop28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51EEDA",
    id: "stop30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 11.5231,
    y1: 0,
    x2: 11.5231,
    y2: 43.0413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AFEBF",
    id: "stop33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51EEDA",
    id: "stop35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 38.5551,
    y1: 37.2499,
    x2: 38.5551,
    y2: 5.79148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AFEBF",
    id: "stop38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51EEDA",
    id: "stop40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.88eb5015ca4a7bf72cc486be1064a581.svg";
export { ForwardRef as ReactComponent };